import CryptoAes from 'crypto-js/aes';
import CryptoEncUtf8 from 'crypto-js/enc-utf8';
import {EncryptData} from './EncryptData.interface';
import {getPassphrase} from './getPassphrase.function';

export function decrypt({
  s: encryptedString,
  k: encryptKey,
  t: type,
}: EncryptData) {
  const passphrase = getPassphrase(encryptKey, type);
  return CryptoAes.decrypt(encryptedString, passphrase).toString(CryptoEncUtf8);
}
